/**
 * @generated SignedSource<<07dd154e3971f92aaa3720ccdabc303e>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type RoomRatesTableRateCell_packageDate$data = {
  readonly id: string;
  readonly " $fragmentSpreads": FragmentRefs<"RoomRatesTableRateEditor_packageDate">;
  readonly " $fragmentType": "RoomRatesTableRateCell_packageDate";
};
export type RoomRatesTableRateCell_packageDate$key = {
  readonly " $data"?: RoomRatesTableRateCell_packageDate$data;
  readonly " $fragmentSpreads": FragmentRefs<"RoomRatesTableRateCell_packageDate">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "RoomRatesTableRateCell_packageDate",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "id",
      "storageKey": null
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "RoomRatesTableRateEditor_packageDate"
    }
  ],
  "type": "PackageDate",
  "abstractKey": null
};

(node as any).hash = "94ddaaa3767fa56d1c7a29693b91a41b";

export default node;
